import React, { Component } from 'react';
import { connect } from "react-redux";
import FormTemplate from "../../common/form/FormTemplate";
import PlatSelectionList from "../../common/selection/PlatSelectionList";
import { searchByTractBookLegal, setSelectedSearchType, SpecialSearchTractBookLegalKey } from "../../../redux/actions/searchActions";
import { LOADING_STATUES, DIRECTION_OPTIONS } from "../../constants/constants";
import { validateDates } from "../../../utils/DateValidation";
import moment from 'moment';

import axios from "axios";
import configData from "../../../config/config.json";
import { handleError } from "../../../redux/actions/commonStuff";
import AjaxResult from "../../../utils/AjaxResult";

const componentName = SpecialSearchTractBookLegalKey;

const matchDispatchToProps = (dispatch) => {
  return {
    setSelectedSearchType: () => dispatch(setSelectedSearchType(componentName)),
    searchByTractBookLegal: (searchCriteria, history, callback) => dispatch(searchByTractBookLegal(searchCriteria, history, callback)),
    resetSearchCriteria: () => dispatch({ type: 'RESET_SEARCH_CRITERIA', componentName }),
    resetSearchSequence: () => dispatch({ type: 'RESET_SEARCH_SEQUENCE'}),
    resetSearchSequenceDocumentNumber: () => dispatch({ type: 'SEARACH_SEARCH_SEQUENCE_DOCUMENT'}),
    resetSearchDetail: () => dispatch({ type: 'RESET_SEARCH_DETAILS'})
  }
}

const mapStateToProps = (state, ownProps) => {
  let previousSearchKeyValue = {};
  if (ownProps.match.params.searchHistoryNumber) {
    let searchHistoryIndex = ownProps.match.params.searchHistoryNumber - 1;
    if (searchHistoryIndex >= 0) {
      let searchHistory = state.searchHistoryReducer.searchHistoryList[searchHistoryIndex];
      if (searchHistory) {
        searchHistory.displayCriteria.forEach((criteria) => {
          previousSearchKeyValue[criteria.key] = criteria.value;
        })
      }
    }
  } else {
    let searchCriteria = state.searchCriteriaReducer[componentName];
    if (searchCriteria) {
      searchCriteria.forEach((criteria) => {
        previousSearchKeyValue[criteria.key] = criteria.value;
      })
    }
  }
  return {
    creditCardUser: state.currentUserReducer.paymentMethod === 'CREDIT_CARD' ? true : false,
    legalType: previousSearchKeyValue.legalType ? previousSearchKeyValue.legalType : 'LB',
    searchMethod: previousSearchKeyValue.searchMethod ? previousSearchKeyValue.searchMethod : 'CONTAINS',
    section: previousSearchKeyValue.section ? previousSearchKeyValue.section : null,
    township: previousSearchKeyValue.township ? previousSearchKeyValue.township : null,
    range: previousSearchKeyValue.range ? previousSearchKeyValue.range : null,
    base: previousSearchKeyValue.base ? previousSearchKeyValue.base : null,
    meridian: previousSearchKeyValue.meridian ? previousSearchKeyValue.meridian : null,
    qqqq: previousSearchKeyValue.qqqq ? previousSearchKeyValue.qqqq : null,
    qqq: previousSearchKeyValue.qqq ? previousSearchKeyValue.qqq : null,
    qq: previousSearchKeyValue.qq ? previousSearchKeyValue.qq : null,
    q: previousSearchKeyValue.q ? previousSearchKeyValue.q : null,
    municipality: previousSearchKeyValue.municipality ? previousSearchKeyValue.municipality : null,
    otherLot: previousSearchKeyValue.otherLot ? previousSearchKeyValue.otherLot : null,
    lot: previousSearchKeyValue.lot ? previousSearchKeyValue.lot : null,
    sublot: previousSearchKeyValue.sublot ? previousSearchKeyValue.sublot : null,
    block: previousSearchKeyValue.block ? previousSearchKeyValue.block : null,
    plat: previousSearchKeyValue.plat ? previousSearchKeyValue.plat : null,
    platName: previousSearchKeyValue.platName ? previousSearchKeyValue.platName : null,
    building: previousSearchKeyValue.building ? previousSearchKeyValue.building : null,
    unit: previousSearchKeyValue.unit ? previousSearchKeyValue.unit : null,
    garage: previousSearchKeyValue.garage ? previousSearchKeyValue.garage : null,
    fromRecordedDate: previousSearchKeyValue.fromRecordedDate ? previousSearchKeyValue.fromRecordedDate : moment('01/01/1900').format('L'),
    toRecordedDate: previousSearchKeyValue.toRecordedDate ? previousSearchKeyValue.toRecordedDate : moment().format('L'),
    otherLotCodes: state.otherLotCodesReducer.codeDescriptionResultList,
    isQQQQ: state.landlinkConfigReducer.qqqq,
    isQQQ: state.landlinkConfigReducer.qqq,
    isBaseline: state.landlinkConfigReducer.baseline,
    isMunicipality: state.landlinkConfigReducer.municipality,
    isMeridian: state.landlinkConfigReducer.meridian,
    isMbOtherLot: state.landlinkConfigReducer.mbOtherLot,
    isSublot: state.landlinkConfigReducer.sublot,
    allPlatList: state.platsReducer.codeDescriptionResultList
  };
}

class SpecialSearchTractBookLegal extends Component {
  state = {
    fromRecordedDate: this.props.fromRecordedDate,
    toRecordedDate: this.props.toRecordedDate,
    legalType: this.props.legalType,
    section: this.props.section,
    township: this.props.township,
    range: this.props.range,
    base: this.props.base,
    meridian: this.props.meridian,
    qqqq: this.props.qqqq,
    qqq: this.props.qqq,
    qq: this.props.qq,
    q: this.props.q,
    municipality: this.props.municipality,
    otherLot: this.props.otherLot,
    lot: this.props.lot,
    sublot: this.props.sublot,
    block: this.props.block,
    plat: this.props.plat,
    platName: this.props.platName,
    building: this.props.building,
    unit: this.props.unit,
    garage: this.props.garage,
    loadingStatus: "",
    submitMessage: '',

    showPlatList: false,

    token: '',
    creditCardPriceListWindowShow: false,
    creditCardAuthorizeDotNetWindowShow: false,
    creditCardPriceListReAuthWindowShow: false,

    platValidated: false,

    errors: {}
  }

  // Same code used in all searches - BEGIN

  componentDidMount() {
    this.props.setSelectedSearchType();
    if (this.props.creditCardUser) {
      axios.post(configData.LANDSHARK_SERVER_URL + "creditcard/authorize", {}, { withCredentials: true })
        .then((response) => {

          let result = new AjaxResult(response);

          if (!result.isOk()) {
            result.handleError();
          } else {
            this.setState({ token: result.content().token });
          }
        }, (error) => {
          handleError(error, this.props.history);
        })
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
      submitMessage: ''
    })

    if (event.target.id === 'platName' && this.state.platValidated === true) {
      this.setState({
        platValidated: false
      })
  
    }
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    }
    return false;
  }

  hideLoading = (message, status, content) => {
    if (content.paymentNeededAgain === true) {
      this.setState({
        loadingStatus: "",
        submitMessage: "",
        creditCardPriceListReAuthWindowShow: true
      })
    } else if (content.paymentNeeded === true) {
      this.setState({
        loadingStatus: "",
        submitMessage: "",
        creditCardPriceListWindowShow: true
      })
    } else if (status === 'ERROR') {
      this.setState({
        loadingStatus: "",
        submitMessage: "",
        creditCardPriceListWindowShow: false,
        creditCardPriceListReAuthWindowShow: false,
        creditCardAuthorizeDotNetWindowShow: false
      })
    } else {
      this.setState({
        loadingStatus: "",
        submitMessage: message,
        creditCardPriceListWindowShow: false,
        creditCardPriceListReAuthWindowShow: false,
        creditCardAuthorizeDotNetWindowShow: false
      })
    }
  }

  handleCreditCardAuthorizeDotNetWindowClose = () => {
    this.setState(
      {
        creditCardAuthorizeDotNetWindowShow: false
      });
  }

  handleCreditCardPriceListClose = () => {
    this.setState(
      {
        creditCardPriceListWindowShow: false
      });
  }

  handleCreditCardPriceListContinue = () => {
    this.setState(
      {
        creditCardAuthorizeDotNetWindowShow: true
      });
  }

  handleCreditCardPriceListReAuth = () => {
    this.setState(
      {
        creditCardAuthorizeDotNetWindowShow: true
      });
  }

  handleCreditCardPriceListReAuthWindowClose = () => {
    this.setState(
      {
        creditCardPriceListReAuthWindowShow: false
      });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.handleValidation()) {
      if (this.showLoading() === true) {
        this.handleAuthorizedSubmit();
      }
    }
  }

  // Same code used in all searches - END

  handleAuthorizedSubmit = () => {
    this.props.resetSearchSequence();
    this.props.resetSearchSequenceDocumentNumber();
    this.props.resetSearchDetail();
    const { loadingStatus, submitMessage, errors, token, creditCardPriceListWindowShow, creditCardAuthorizeDotNetWindowShow, creditCardPriceListReAuthWindowShow, ...request } = this.state; // remove UI only fields before submitting
    this.props.searchByTractBookLegal(request, this.props.history, this.hideLoading);
  }

  validatePlat = (platEntry) => {
    const moreThanOneWord = platEntry.indexOf(' ') >= 0;
    let foundPlats = [];
    if (moreThanOneWord) {
      foundPlats = this.props.allPlatList.filter(plat => plat.description.toUpperCase().indexOf(platEntry) >= 0)
    } else {
      foundPlats = this.props.allPlatList.filter(plat => plat.code === platEntry || plat.description.toUpperCase().indexOf(platEntry) >= 0)
    }

    if (!foundPlats || foundPlats.length === 0) {
      let errors = {};
      errors["platName"] = "No matching plat found.";
      this.setState({
        plat: '',
        errors: errors
      })
      return false;
    } else if (foundPlats.length === 1) {
      let currentPlat = this.state.plat;
      const foundPlat = foundPlats[0];
      this.setState({
        platName: foundPlat.description,
        plat: foundPlats[0].code
      })
      if (currentPlat !== foundPlat.code) {
        return false;
      } else {
        return true;
      }
    } else if (foundPlats.length > 1) {
      let errors = {};
      errors["platName"] = "More than 1 match found.";
      this.setState({
        plat: '',
        errors: errors
      })
      return false;
    }
  }

  handleValidation() {
    let errors = {};

    if (this.state.legalType === 'LB' && this.state.platValidated === false) {
        let platValid = this.validatePlat(this.state.platName.toUpperCase());
        if (platValid === false) {
          return false;
        }
    }

    let formIsValid = validateDates(errors, this.state.fromRecordedDate, 'fromRecordedDate', this.state.toRecordedDate, 'toRecordedDate');
    if (!formIsValid) {
      this.setState({ errors: errors });
      return false;
    }

    this.setState({ errors: errors });
    return true;
  }

  handleClear = (event) => {
    event.preventDefault();
    this.props.resetSearchCriteria();

    let fromRecordedDate = moment('01/01/1900').format('L');
    if (this.props.showNotableDates === true) {
      fromRecordedDate = this.props.abstractIndexBeginDate;
    } 
  
    let toRecordedDate = moment().format('L');
    if (this.props.useVerificationDate === true) {
      toRecordedDate = this.props.abstractVerifiedDate;
    }

    this.setState({
      documentType: 'ALL',
      fromRecordedDate,
      toRecordedDate,
      section: '',
      township: '',
      range: '',
      base: '',
      meridian: '',
      qqqq: '',
      qqq: '',
      qq: '',
      q: '',
      municipality: '',
      otherLotMb: '',
      otherLotLb: '',
      otherLotCodeMb: '',
      otherLotCodeLb: '',
      lot: '',
      sublot: '',
      block: '',
      plat: '',
      platName: '',
      building: '',
      unit: '',
      garage: '',
      submitMessage: '',
      platValidated: false,
      errors: {}
    })
  }

  handleDatePickerChangeFromRecordedDate = (date) => {
    this.setState({
      fromRecordedDate: moment(date).format('L')
    })
  }

  handleDatePickerChangeToRecordedDate = (date) => {
    this.setState({
      toRecordedDate: moment(date).format('L')
    })
  }

  handlePlatNumberBlur = (event) => {
    event.preventDefault();
    const originalPlatEntry = event.target.value.trim();
    if (!originalPlatEntry || originalPlatEntry === '') {
      this.setState({ platName: '' });
      return;
    }
    const platEntry = originalPlatEntry.toUpperCase();
    this.validatePlat(platEntry)
  }

  handlePlatLookup = () => {
    this.setState({
      showPlatList: true
    });
  }

  handleClosePlatLookup = (selectedId, selectedName) => {
  
    this.setState({
      errors: {},
      showPlatList: false
    })

    if (selectedId) {
      this.setState({
        plat: selectedId,
        platName: selectedName,
        platValidated: true
      })
    }
  }

  render() {
    var hideBaseMeridianMunicipalityRow = this.state.legalType !== 'MB' || (this.props.isBaseline === false && this.props.isMunicipality === false && this.props.isMeridian === false)

    const formProps = {
      componentName: componentName,
      pageHeading: "Tract Book Search by Legal",
      onChange: this.handleChange,
      onSubmit: this.handleSubmit,
      onClear: this.handleClear,
      successIndicator: this.state.loadingStatus === LOADING_STATUES.SUCCESS,
      loadingIndicator: this.state.loadingStatus === LOADING_STATUES.LOADING,
      submitMessage: this.state.submitMessage,
      formGroupRows: [
        {
          formGroups: [{ id: 'legalType', label: 'Legal Type', fieldType: 'select', primaryCriteria: true, value: this.state.legalType, options: [{ code: 'LB', description: 'Lots & Blocks' }, { code: 'MB', description: 'Metes & Bounds' }] },
          { id: 'searchMethod', label: '', fieldType: 'select', primaryCriteria: true, value: this.state.searchMethod, options: [{ code: 'CONTAINS', description: 'Contains' }, { code: 'EXACT', description: 'Matches Exactly' }] }]
        },
        {
          formGroups: [{ id: 'section', label: 'Section', fieldType: 'text', primaryCriteria: true, hideRow: this.state.legalType !== 'MB', required: this.state.legalType === 'MB', value: this.state.section },
          { id: 'township', label: 'Township', fieldType: 'text', primaryCriteria: true, required: this.state.legalType === 'MB', value: this.state.township },
          { id: 'range', label: 'Range', fieldType: 'text', primaryCriteria: true, required: this.state.legalType === 'MB', value: this.state.range }]
        },
        {
          formGroups: [{ id: 'qqqq', label: 'QQQQ', fieldType: 'select', options: DIRECTION_OPTIONS, hideRow: this.state.legalType !== 'MB', hideField: this.props.isQQQQ === false, value: this.state.qqqq },
          { id: 'qqq', label: 'QQQ', fieldType: 'select', options: DIRECTION_OPTIONS, hideField: this.props.isQQQ === false, value: this.state.qqq },
          { id: 'qq', label: 'QQ', fieldType: 'select', options: DIRECTION_OPTIONS, value: this.state.qq },
          { id: 'q', label: 'Q', fieldType: 'select', options: DIRECTION_OPTIONS, value: this.state.q }]
        },
        {
          formGroups: [{ id: 'base', label: 'Base', fieldType: 'text', hideRow: hideBaseMeridianMunicipalityRow, hideField: this.props.isBaseline === false, value: this.state.base },
          { id: 'meridian', label: 'Meridian', fieldType: 'text', hideField: this.props.isMeridian === false, value: this.state.meridian },
          { id: 'municipality', label: 'Municipality', fieldType: 'text', hideField: this.props.isMunicipality === false, value: this.state.municipality }]
        },
        {
          formGroups: [{ id: 'platName', label: 'Plat', primaryCriteria: true, onBlur: this.handlePlatNumberBlur, fieldType: 'text', required: this.state.legalType === 'LB', hideRow: this.state.legalType === 'MB', value: this.state.platName, error: this.state.errors['platName'] },
          { id: 'platLookupButton', fieldType: 'lookup', onClick: this.handlePlatLookup }]
        },
        {
          formGroups: [{ id: 'lot', label: 'Lot', fieldType: 'text', hideRow: this.state.legalType === 'MB', hideField: this.state.legalType === 'MB', value: this.state.lot },
          { id: 'block', label: 'Block', fieldType: 'text', hideField: this.state.legalType === 'MB', value: this.state.block },
          { id: 'sublot', label: 'Sublot', fieldType: 'text', hideField: this.state.legalType === 'MB' || this.props.isSublot === false, value: this.state.sublot }]
        },
        {
          formGroups: [{ id: 'otherLotCodeLb', label: 'Other Lot Type', fieldType: 'select', hideRow: this.state.legalType === 'MB' || this.props.isMbOtherLot === false, options: this.props.otherLotCodes, value: this.state.otherLotCodeLb },
          { id: 'otherLotLb', label: 'Other Lot', fieldType: 'text', value: this.state.otherLotLb }]
        },
        {
          formGroups: [{ id: 'otherLotCodeMb', label: 'Other Lot Type', fieldType: 'select', hideRow: this.state.legalType !== 'MB' || this.props.isMbOtherLot === false, options: this.props.otherLotCodes, value: this.state.otherLotCodeMb },
          { id: 'otherLotMb', label: 'Other Lot', fieldType: 'text', value: this.state.otherLotMb }]
        },
        {
          formGroups: [{ id: 'building', label: 'Building', fieldType: 'text', hideRow: this.state.legalType === 'MB', value: this.state.building },
          { id: 'unit', label: 'Unit', fieldType: 'text', value: this.state.unit },
          { id: 'garage', label: 'Garage', fieldType: 'text', value: this.state.garage }]
        },
        {
          formGroups: [{ id: 'fromRecordedDate', label: 'From Date', fieldType: 'date', value: this.state.fromRecordedDate, handleDatePickerChange: this.handleDatePickerChangeFromRecordedDate, error: this.state.errors['fromRecordedDate'] }]
        },
        {
          formGroups: [{ id: 'toRecordedDate', label: 'To Date', fieldType: 'date', value: this.state.toRecordedDate, handleDatePickerChange: this.handleDatePickerChangeToRecordedDate, error: this.state.errors['toRecordedDate'] }]
        }
      ],

      handleAuthorizedSubmit: this.handleAuthorizedSubmit,

      // price list window
      creditCardPriceListWindowShow: this.state.creditCardPriceListWindowShow,
      handleCreditCardPriceListClose: this.handleCreditCardPriceListClose,
      handleCreditCardPriceListContinue: this.handleCreditCardPriceListContinue,

      // authoriz.net iframe window
      creditCardAuthorizeDotNetWindowShow: this.state.creditCardAuthorizeDotNetWindowShow,
      handleCreditCardAuthorizeDotNetWindowClose: this.handleCreditCardAuthorizeDotNetWindowClose,
      authorizeDotNetToken: this.state.token,

      // re-preauth price list window
      creditCardPriceListReAuthWindowShow: this.state.creditCardPriceListReAuthWindowShow,
      handleCreditCardPriceListReAuth: this.handleCreditCardPriceListReAuth,
      handleCreditCardPriceListReAuthWindowClose: this.handleCreditCardPriceListReAuthWindowClose
    }
    return (
      <>
      <FormTemplate {...formProps} />
      <PlatSelectionList showModal={this.state.showPlatList} onHide={(selectedId, selectedName) => this.handleClosePlatLookup(selectedId, selectedName)} />
      </>
    )
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(SpecialSearchTractBookLegal);